var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleSheetsLogo32X32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1036_1451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L9.27273 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1036_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L11.0909 2.54545L9.27273 0Z",
    fill: "#0F9D58"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1036_1451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L9.27273 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1036_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.909 7.81818V13.0909H10.7272V7.81818H4.909ZM7.45445 12.3636H5.63627V11.4545H7.45445V12.3636ZM7.45445 10.9091H5.63627V9.99999H7.45445V10.9091ZM7.45445 9.45454H5.63627V8.54545H7.45445V9.45454ZM9.99991 12.3636H8.18172V11.4545H9.99991V12.3636ZM9.99991 10.9091H8.18172V9.99999H9.99991V10.9091ZM9.99991 9.45454H8.18172V8.54545H9.99991V9.45454Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1036_1451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L9.27273 0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1036_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5918 4.04456L13.6363 8.08819V4.36365L9.5918 4.04456Z",
    fill: "url(#paint0_linear_1036_1451)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1036_1451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L9.27273 0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1036_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.27264 0V3.27273C9.27264 3.87545 9.76083 4.36364 10.3636 4.36364H13.6363L9.27264 0Z",
    fill: "#87CEAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1036_1451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L9.27273 0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1036_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09091 0C2.49091 0 2 0.490909 2 1.09091V1.18182C2 0.581818 2.49091 0.0909091 3.09091 0.0909091H9.27273V0H3.09091Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1036_1451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L9.27273 0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1036_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5455 15.9091H3.09091C2.49091 15.9091 2 15.4182 2 14.8182V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V14.8182C13.6364 15.4182 13.1455 15.9091 12.5455 15.9091Z",
    fill: "#263238",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1036_1451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L9.27273 0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1036_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3636 4.36364C9.76083 4.36364 9.27264 3.87546 9.27264 3.27274V3.36364C9.27264 3.96637 9.76083 4.45455 10.3636 4.45455H13.6363V4.36364H10.3636Z",
    fill: "#263238",
    fillOpacity: 0.1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27273 0H3.09091C2.49091 0 2 0.490909 2 1.09091V14.9091C2 15.5091 2.49091 16 3.09091 16H12.5455C13.1455 16 13.6364 15.5091 13.6364 14.9091V4.36364L9.27273 0Z",
    fill: "url(#paint1_radial_1036_1451)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1036_1451",
    x1: 11.6143,
    y1: 4.39175,
    x2: 11.6143,
    y2: 8.08876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1036_1451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.36865 0.318033) scale(18.7635 18.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSheetsLogo32X32);
export default __webpack_public_path__ + "static/media/Google-Sheets-Logo-32x32.a793c1b6.svg";
export { ForwardRef as ReactComponent };